import { useMemo } from 'react';
import type { PositionWithOffsetValue } from '@elfsight/configurator-contracts';
import type { WebsiteTranslatorSettings } from '../../../types';

type AlignmentValue = 'flex-start' | 'flex-end' | 'center';

type UseEmbedPositionProps = {
  embedType: WebsiteTranslatorSettings['embedType'];
  position: PositionWithOffsetValue;
};

export function useEmbedPosition({
  embedType,
  position
}: UseEmbedPositionProps) {
  const {
    position: positionValue,
    verticalOffset,
    horizontalOffset
  } = position;

  const alignment = useMemo((): AlignmentValue => {
    if (embedType === 'inline') {
      return 'center';
    }

    if (positionValue.includes('left')) {
      return 'flex-start';
    }

    if (positionValue.includes('right')) {
      return 'flex-end';
    }

    return 'center';
  }, [embedType, positionValue]);

  const floatingMargin = useMemo((): string => {
    if (positionValue === 'top' || positionValue === 'bottom') {
      return `${verticalOffset}px 0`;
    }

    if (positionValue === 'left' || positionValue === 'right') {
      return `0 ${horizontalOffset}px`;
    }

    return `${verticalOffset}px ${horizontalOffset}px`;
  }, [positionValue, verticalOffset, horizontalOffset]);

  return { alignment, floatingMargin };
}
